// src/services/email/effectiveAnrede.ts
//
// Personengebundene Du-Anrede: Zentrale Regel für alle Frontend-Versandwege.
//
// Die Du-Form ist personengebunden — ein Kunde wird nur dann geduzt, wenn der
// konkrete Absender der E-Mail in der Duz-Liste des Kunden steht
// (customers.duz_mitarbeiter_ids). Andernfalls wird konservativ gesiezt,
// auch wenn beim Kunden bzw. Kontakt die Anrede "Du" hinterlegt ist.
//
// Verhalten:
// - anrede !== 'Du' (also 'Sie', null oder undefined): Wert wird unverändert
//   zurückgegeben — bestehendes Verhalten bleibt vollständig erhalten.
// - anrede === 'Du': 'Du' nur, wenn senderId in duzMitarbeiterIds enthalten
//   ist, sonst 'Sie'.

export function resolveEffectiveAnrede(
  anrede: string | null | undefined,
  senderId: string | null | undefined,
  duzMitarbeiterIds: string[] | null | undefined
): string | null | undefined {
  if (anrede !== 'Du') {
    return anrede;
  }
  const senderDarfDuzen = !!(
    senderId &&
    Array.isArray(duzMitarbeiterIds) &&
    duzMitarbeiterIds.includes(senderId)
  );
  return senderDarfDuzen ? 'Du' : 'Sie';
}
